export default __webpack_public_path__ + "static/media/m_quiz_bg.6b455f12.png";